import React, { useContext } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import allDocuments from "../Workdoc/typedoc";

export default function WorkdocTypedocList(props) {
  const cx = useContext(Context);

  let avDocuments = props.documents || [];
  allDocuments.forEach((doc) => {
    if (doc.inTypedocList) {
      if (cx.user.isClassManageable(doc.key)) {
        avDocuments.push(doc);
      }
    }
  });

  return (
    <Modal size="lg" show onHide={props.onHide}>
      <Modal.Header closeButton>
        <Modal.Title className="w-100">Новый документ</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          {avDocuments.map((doc) => {
            let item = doc || {};
            return (
              <div className="col-lg-4" key={doc.key}>
                <Link to={item.url} onClick={props.onHide}>
                  <div
                    className={`card cursor-pointer card-custom card-stretch gutter-b bg-hover-light`}
                  >
                    <div className="card-body">
                      <span
                        className={`svg-icon svg-icon-${item.iconColor} svg-icon-3x ml-n1`}
                      >
                        {item.icon}
                      </span>
                      <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                        {item.label}
                      </div>
                      <div className="font-weight-bold text-inverse-white font-size-sm">
                        {item.description}
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button onClick={props.onHide} className="btn btn-light">
          Отмена
        </button>
      </Modal.Footer>
    </Modal>
  );
}
